import { Pipe, PipeTransform } from '@angular/core';
import { ACTIVITY_STATUS } from '../abp-tabs.constants';

@Pipe({
  name: 'activityStatus',
})
export class ActivityStatusPipe implements PipeTransform {
  activityStatus: typeof ACTIVITY_STATUS = ACTIVITY_STATUS;

  transform(status: string): string {
    if (!status) {
      return '';
    }

    // Handle new API status format
    switch (status) {
      case 'PENDING_REVIEW':
      case 'SCHEDULED':
        return 'activity-button-scheduled';
      case 'PUBLISHED':
      case 'ACTIVE':
      case 'LIVE':
        return 'activity-button-published';
      case 'REJECTED':
      case 'FAILED':
        return 'activity-button-failed';
      case 'INACTIVE':
      case 'UNPUBLISHED':
        return 'activity-button-unpublished';
      case 'SUSPENDED':
        return 'activity-button-unpublished';
      case 'DRAFT':
        return 'activity-button-draft';
      default:
        // Handle old status format (enum values)
        switch (status) {
          case this.activityStatus.PUBLISHED:
            return 'activity-button-published';
          case this.activityStatus.DRAFT:
            return 'activity-button-draft';
          case this.activityStatus.SCHEDULED:
            return 'activity-button-scheduled';
          case this.activityStatus.INACTIVE:
            return 'activity-button-inactive';
          case this.activityStatus.UNPUBLISHED:
            return 'activity-button-unpublished';
          case this.activityStatus.DELETE_SCHEDULED:
          case this.activityStatus.UNPUBLISH_SCHEDULED:
          case this.activityStatus.PROCESSING:
          case this.activityStatus.UNPUBLISH_PROCESSING:
          case this.activityStatus.DELETE_PROCESSING:
            return 'activity-button-processing';
          case this.activityStatus.FAILED:
            return 'activity-button-failed';
          default:
            // Default to scheduled style for unknown statuses
            return 'activity-button-scheduled';
        }
    }
  }
}
